import { render, staticRenderFns } from "./TrustscoreBlock.vue?vue&type=template&id=475be35b"
import script from "./TrustscoreBlock.vue?vue&type=script&lang=js"
export * from "./TrustscoreBlock.vue?vue&type=script&lang=js"
import style0 from "./TrustscoreBlock.vue?vue&type=style&index=0&id=475be35b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports